import React from 'react';
import { Box, Flex, Icon, Text, VStack } from '@chakra-ui/react';
import { FiClipboard, FiShield } from 'react-icons/fi';
import ModalShell from '../../../components/ui/ModalShell';
import { ff } from '../../../theme';
import WalletIntroIllustration from './WalletIntroIllustration';

const FEATURES = [
  {
    icon: FiClipboard,
    title: 'A few more steps upfront',
    desc: 'We know setting up payouts takes a little more info than before.',
  },
  {
    icon: FiShield,
    title: 'But you only set it up once',
    desc: 'Once your wallet is set up and verified, you\u2019re all set for future payouts. \uD83D\uDC9A',
  },
] as const;

export interface WalletPayoutIntroModalProps {
  isOpen: boolean;
  onClose: () => void | Promise<void>;
  onSetup: () => void | Promise<void>;
  isSetupLoading?: boolean;
}

const WalletPayoutIntroModal: React.FC<WalletPayoutIntroModalProps> = ({
  isOpen,
  onClose,
  onSetup,
  isSetupLoading = false,
}) => (
  <ModalShell
    isOpen={isOpen}
    onClose={() => void onClose()}
    size="sm"
    primary={{
      label: 'Set up my wallet',
      onClick: () => void onSetup(),
      isLoading: isSetupLoading,
      loadingText: 'Starting setup…',
    }}
  >
    <Box textAlign="center">
      <Box mb={4}>
        <WalletIntroIllustration />
      </Box>
      <Text as="h2" textStyle="display" fontSize="28px" color={ff.ink}>
        Hey! We heard you...
      </Text>
      <Text fontSize="15px" color={ff.text2} mt={2} lineHeight="1.5">
        We&apos;ve moved to a new payouts provider.
      </Text>
    </Box>

    <VStack
      spacing={0}
      align="stretch"
      mt={5}
      border="1px solid"
      borderColor={ff.line}
      borderRadius="20px"
      px={4}
      divider={<Box h="1px" bg={ff.line} border="none" />}
    >
      {FEATURES.map((feature) => (
        <Flex key={feature.title} gap={3} align="flex-start" py={4}>
          <Flex
            w="44px"
            h="44px"
            borderRadius="full"
            bg={ff.lime}
            align="center"
            justify="center"
            flexShrink={0}
          >
            <Icon as={feature.icon} boxSize={5} color={ff.ink} />
          </Flex>
          <VStack align="start" spacing={1} flex={1}>
            <Text fontWeight="600" fontSize="15px" color={ff.ink}>
              {feature.title}
            </Text>
            <Text fontSize="14px" color={ff.text2} lineHeight="1.5">
              {feature.desc}
            </Text>
          </VStack>
        </Flex>
      ))}
    </VStack>
  </ModalShell>
);

export default WalletPayoutIntroModal;
